import axios from 'axios'
export default {
  // ==========================List Management=============================
  list (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/rpiclient', { params: opts })
        .then(({ data }) => {
          context.commit('LIST', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  update (context, opts) {
    if (opts.id && (opts.organization || opts.system)) {
      const params = opts.system ? { system: opts.system } : { organization: opts.organization }
      return new Promise((resolve, reject) => {
        axios
          .patch(`/api/rpiclient/${opts.id}`, params)
          .then(({ data }) => {
            resolve(data)
          }).catch((error) => reject(error))
      })
    }
  },
  async clientSignal (context, opts) {
    try {
      const params = {
        id: opts.id,
        type: 'rpiclient',
        signal: opts.signal
      }
      await axios.post('/api/client/signal', params)
    } catch (err) {
      console.log(err)
    }
  }
}
